<template>
    <ui-modal>
        <template #header>
            <h3 v-text="'Powiązanie sklepów'" class="mb-0" />
            <h5 v-text="'Wybór sklepów'" class="text-center mb-0" />
        </template>

        <div>
            <div
                v-text="`UWAGA! Posiadasz sklepy w Kaucyjni.pl. Dla poprawnego działania systemu kaucyjnego wskaż, który
                    sklep z Kaucyjni.pl odpowiada sklepowi z EuroPlaform. Jeśli dany sklep nie ma swojego odpowiednika w
                    Kaucyjni.pl, wybierz opcję “Brak” - utworzysz w ten sposób brakujący sklep w portalu Kaucyjni.pl.`"
                class="a-infoBar a-infoBar--warning text-sm mb-3"
            />

            <div class="c-table location-mapping-table">
                <div class="c-thead">
                    <div v-text="'Sklep EuroPlatform'" class="c-td is-1" />
                    <div v-text="'Sklep Kaucyjni.pl'" class="c-td" />
                </div>
                <div class="c-tbody">
                    <location-mapping-row
                        v-for="loc in locations"
                        :key="loc.id"
                        :location="loc"
                        :replicated-location="replicatedLocations[loc.id]"
                        :selected-option="mappings[loc.id]"
                        :options="getAvailableOptions(loc.id)"
                        @select="updateMapping(loc.id, $event)"
                    />
                </div>
            </div>
        </div>
        <template #footer>
            <the-btn
                text="Wróć"
                class="btn-outline-custom"
                @click="goBack"
            />
            <the-btn
                text="Zobacz podsumowanie"
                class="btn-secondary"
                :disabled="!isAllLocationSelected"
                @click="goToSummary"
            />
        </template>
    </ui-modal>
</template>

<script>
import locationMappingMixin, { VALID_DATA_STATUS } from '@/components/drs/service/location-mapping.mixin'

export default {
    mixins: [locationMappingMixin],

    provide() {
        return {
            closeModal: this.closeModalAndClearState
        }
    },

    data: () => ({
        mappings: {}
    }),

    created() {
        this.$store.dispatch('extendedDataFetch', { includes: 'locations' })
        this.mappings = this.$store.getters.drsLocationMappings
    },

    computed: {
        locations() {
            return this.$store.getters.locationsToActivate
        },

        replicatedLocations() {
            return this.$store.getters.replicatedLocationsByEpId
        },

        allOptions() {
            return [
                {
                    id: VALID_DATA_STATUS.NONE,
                    name: 'Brak (nie ma wskazanego sklepu w Kaucyjni.pl)'
                },
                ...this.$store.getters.unMappedDrsLocations
            ]
        },

        selectedIdsToMap() {
            return Object.values(this.mappings).filter(
                value => value && value !== VALID_DATA_STATUS.NONE
            )
        },

        isAllLocationSelected() {
            return this.locations.every(loc => {
                return !!this.replicatedLocations[loc.id] || !!this.mappings[loc.id]
            })
        }
    },

    methods: {
        updateMapping(locId, value) {
            this.$set(this.mappings, locId, value)
        },

        getAvailableOptions(locId) {
            return this.allOptions.map(option => {
                return {
                    ...option,
                    disabled: option.id !== VALID_DATA_STATUS.NONE &&
                        this.selectedIdsToMap.includes(option.id) &&
                        !this.mappings[locId] !== option.id
                }
            })
        },

        goBack() {
            this.$store.dispatch('openModal', {
                componentPath: 'drs/service/LocationMappingIntro'
            })
        },

        goToSummary() {
            this.$store.dispatch('saveDrsLocationMappings', this.mappings)

            this.$store.dispatch('openModal', {
                componentPath: 'drs/service/LocationMappingSummary'
            })
        }
    }
}
</script>